import React from 'react';
import './dropdown-menu.css';

const Root = ({ children }) => {
  return <div className="dropdown-root">{children}</div>;
};

const Trigger = ({ children, asChild }) => {
  return asChild ? children : <button className="dropdown-trigger">{children}</button>;
};

const Portal = ({ children }) => {
  return <div className="dropdown-portal">{children}</div>;
};

const Content = ({ children, side = 'bottom', align = 'start', sideOffset = 0, asChild }) => {
  const contentClass = `dropdown-content dropdown-${side} dropdown-align-${align}`;
  return asChild ? React.cloneElement(children, {
    className: `${children.props.className} ${contentClass}`,
    style: { '--side-offset': `${sideOffset}px` }
  }) : (
    <div className={contentClass} style={{ '--side-offset': `${sideOffset}px` }}>
      {children}
    </div>
  );
};

const Item = ({ children, icon, onClick }) => {
  return (
    <button className="dropdown-item" onClick={onClick}>
      {icon && <span className="dropdown-item-icon">{icon}</span>}
      {children}
    </button>
  );
};

export const DropdownMenu = ({ children }) => {
  return <div className="dropdown-menu">{children}</div>;
};

DropdownMenu.Root = Root;
DropdownMenu.Trigger = Trigger;
DropdownMenu.Portal = Portal;
DropdownMenu.Content = Content;
DropdownMenu.Item = Item;
DropdownMenu.DropdownItem = Item; // For backward compatibility 